<script>
import {
  get,
  postForm,
  getIbeHost,
  getCDNHost,
} from "shared/Utilities/fetchUtilities";

export default {
  mounted() {
  },
  props: {
    signupFeeAmount: {
      type: String,
      default: "",
    },
    enrollmentFeeAmount: {
      type: String,
      default: "",
    },
    discountedEnrollmentFeeAmount: {
      type: String,
      default: "",
    },
    totalAmount: {
      type: String,
      default: "",
    },
    backgroundColor:{
        type: String,
        default: "#ebebeb",
    },
    color:{
        type: String,
        default: "#4c4c4c",
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
};
</script>

<template>
  <div class="dd-limited-price-container" :style="'background-color:' + this.backgroundColor">
    <div class="membership-content">
      <div class="column-one">
        <div class="callout-content">
          <div class="banner">
            <div class="text">
              <span>LIMITED TIME ONLY!</span>
            </div>
            <div class="triangle" :style="'border-right:12px solid '+ this.backgroundColor"></div>
          </div>
        </div>
        <span :style="'color:' + this.color">Annual Membership:</span>
        <span :style="'color:' + this.color">Enrollment Fee:</span>
      </div>
      <div class="column-two" :style="'color:' + this.color">
        <span class="column-empty"></span>
        <span class="numeric-text">{{signupFeeAmount}}</span>
        <span class="numeric-text">
          <span class="line-through">{{enrollmentFeeAmount}}</span>&nbsp;&nbsp;{{discountedEnrollmentFeeAmount}}
        </span>
      </div>
    </div>
    <div class="membership-content">
      <hr class="horizontal-line" />
    </div>
    <div class="membership-content" :style="'color:' + this.color">
      <div class="column-one">
        <span class="you-pay-text">You pay!</span>
      </div>
      <div class="column-two">
        <span class="numeric-text">{{totalAmount}}</span>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "~less-variables";
.dd-limited-price-container {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
  margin-top: 9%;
  background-color: #ebebeb;
  height: 167px;
  flex-direction: column;
  
  .callout-content {
    width: 211px;
    height: 29px;
    background-color: #e5af22;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    flex: 0 auto;
    margin-top: 19px;
    margin-bottom: 20px;
    margin-left: 10%;
    .banner {
      width: 211px;
      height: 28px;
      background-color: #e5af22;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: stretch;
      flex: 0 auto;
      .text {
        width: 100%;
        color: #2a3e30;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 700;
        font-style: normal;
        letter-spacing: normal;
        line-height: normal;
        text-align: left;
        text-transform: uppercase;
        font-style: normal;
        letter-spacing: normal;
        line-height: normal;
        padding-left: 8px;
        padding-top: 5px;
      }
      .triangle {
        border-top: 15px solid transparent;
        border-right: 12px solid #ebebeb;
        border-bottom: 15px solid transparent;
        margin-right: -1px;
      }
    }
  }
  .membership-content {
    text-align: right;
    color: #4c4c4c;
    font-family: Montserrat;
    font-size: 18px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    display: flex;
    flex-direction: row;
    .column-empty {
      height: 61%;
    }
    .column-one {
      display: flex;
      flex-direction: column;
    }
    .column-two {
      display: flex;
      flex-direction: column;
      text-align: left;
      min-width: 146px;
    }
    .numeric-text {
      font-weight: 700;
      padding-left: 25px;
      min-width: 156px;

      .line-through {
        position: relative;
      }
      .line-through:before {
        position: absolute;
        content: "";
        left: 0;
        top: 40%;
        right: 0;
        border-top: 4px solid;
        border-color: #e93139;
        transform: rotate(-10deg);
      }
    }
    .you-pay-text {
      width: 211px;
    }
    .horizontal-line {
      width: 356px;
      margin-left: -20px;
    }
  }
}

@media screen and (max-width: 414px) {
  .dd-limited-price-container {
    height: 154px;
    .callout-content {
      margin-left: 20%;
    }

    .membership-content {
      font-size: 16px;
      .column-empty {
        height: 64%;
      }

      .numeric-text {
        padding-left: 15px;
      }

      .horizontal-line {
        width: 281px;
        margin-left: -20px;
      }
    }
  }
}
</style>
